var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgKeyboard(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 14,
    viewBox: "0 0 17 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.00195 2V12H14.002V2H2.00195ZM1.00195 0C0.449668 0 0.00195312 0.447716 0.00195312 1V13C0.00195312 13.5523 0.449668 14 1.00195 14H15.002C15.5542 14 16.002 13.5523 16.002 13V1C16.002 0.447715 15.5542 0 15.002 0H1.00195ZM4.00195 8H12.002V10H4.00195V8ZM6.00195 4H4.00195V6H6.00195V4ZM7.00195 4H9.00195V6H7.00195V4ZM12.002 4H10.002V6H12.002V4Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgKeyboard);
export default __webpack_public_path__ + "static/media/keyboard.a5386de5f28cd17ed171cf740b9f2074.svg";
export { ForwardRef as ReactComponent };